/**
 * Thrown by `parse()` when a template contains a syntax error
 * (unclosed `{{`, empty `{{}}`, invalid identifier, nested `{{{{`).
 *
 * Runtime resolution failures do **not** throw — missing paths resolve to
 * `undefined` per ADR-12. `InterpolationError` is reserved for
 * parser-detected structural problems that callers should surface loudly so
 * publish-time validators (ADR-8, §12) can catch them statically.
 */
export class InterpolationError extends Error {
  public readonly template: string;
  public readonly position?: number;

  constructor(message: string, template: string, position?: number) {
    super(
      position !== undefined
        ? `${message} (at position ${position} in ${JSON.stringify(template)})`
        : `${message} (in ${JSON.stringify(template)})`,
    );
    this.name = 'InterpolationError';
    this.template = template;
    this.position = position;
    Object.setPrototypeOf(this, InterpolationError.prototype);
  }
}
